import { searchContacts } from "./contacts/searchContacts.js";
import { createConversation } from "./conversation/createConversation.js";
import { getConversations } from "./conversation/getConversations.js";
import { setConversationCategory } from "./conversation/setConversationCategory.js";
import { setConversationIsRead } from "./conversation/setConversationIsRead.js";
import { getConversationContact } from "./conversations/getConversationContact.js";
import { getEvent } from "./events/getEvent.js";
import { getMyEvents } from "./events/getMyEvents.js";
import { searchGifs } from "./gif/searchGifs.js";
import { downloadFile } from "./file/downloadFile.js";
import { isLinkedinConnectNoteRestricted } from "./global/isLinkedinConnectNoteRestricted.js";
import { getGroups } from "./groups/getGroups.js";
import { removePending } from "./invitation/removePending.js";
import { getRealPostURL } from "./linkedinPost/getRealPostURL.js";
import { deleteMessage } from "./message/deleteMessage.js";
import { editMessage } from "./message/editMessage.js";
import { getConversationMessages } from "./message/getConversationMessages.js";
import { sendMessage } from "./message/sendMessage.js";
import { getInfosFromUrls } from "./profile/getInfosFromUrls.js";
import { getProfileData } from "./prospects/getProfileData.js";
import { refreshProspect } from "./prospects/refreshProspect.js";
import { getLeadsLists } from "./sales/getLeadsLists.js";
import { getSavedSearches } from "./sales/getSavedSearches.js";
import { getCompany } from "./user/getCompany.js";
import { getConnectionsCount } from "./user/getConnectionsCount.js";
import { getInvitationsCount } from "./user/getInvitationsCount.js";
import { getViewersCount } from "./user/getViewersCount.js";
import { CloudCommand } from "./types.js";

/**
 * Single source of truth for action -> girbal command mappings, shared by mystique
 * (cloud) and mew (extension). Add an entry here to route an action through a girbal
 * command on both sides.
 */
const commands: CloudCommand[] = [
    getGroups,
    getRealPostURL,
    isLinkedinConnectNoteRestricted,
    searchGifs,
    createConversation,
    getConversations,
    setConversationCategory,
    setConversationIsRead,
    getConversationContact,
    searchContacts,
    getConversationMessages,
    editMessage,
    deleteMessage,
    sendMessage,
    downloadFile,
    getInfosFromUrls,
    getProfileData,
    refreshProspect,
    getMyEvents,
    getEvent,
    removePending,
    getLeadsLists,
    getSavedSearches,
    getCompany,
    getConnectionsCount,
    getInvitationsCount,
    getViewersCount,
];

export const ACTION_TO_COMMAND: Record<string, CloudCommand> = Object.fromEntries(commands.map((command) => [command.action, command]));
